/* eslint-disable prettier/prettier */
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import AudioPlayer from 'components/AudioPlayer';

import ArtworkImage from '../ArtworkImage';
import ArtworkImageLoading from '../Loading/components/ArtworkImageLoading';
import CollectorComments from './components/CollectorComments';
import HistoricalImages from './components/HistoricalImages';
import SameCollectionArtworks from './components/SameCollectionArtworks';
import useStyles from './styles';

const ArtworkDetailRight = ({ loading, artwork }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    description,
    artist,
    year_created,
    id,
    owner,
    is_owner,
    audio_file,
    show_comments,
    comments,
  } = artwork || {};

  return (
    <Box className={classes.wrapArtworkDetail}>
      <Box className={classes.artworkImage}>
        {loading ? <ArtworkImageLoading /> : <ArtworkImage artwork={artwork} />}
      </Box>

      <HistoricalImages artworkId={id} />

      {(description || audio_file) && (
        <div>
          <Text className={classes.textAboutWork}>{t('about_artwork')}</Text>
        </div>
      )}

      {audio_file && (
        <Box sx={{ mt: 3 }}>
          <AudioPlayer audioUrl={audio_file} />
        </Box>
      )}

      {description && (
        <div>
          <Text className={classes.textDescription}>{description}</Text>
        </div>
      )}

      {show_comments && <CollectorComments comments={comments} />}

      {is_owner && (
        <SameCollectionArtworks
          artistId={artist?.id}
          yearCreated={year_created}
          artworkId={id}
          owner={owner}
        />
      )}
    </Box>
  );
};

export default ArtworkDetailRight;
